/** @jsxImportSource @emotion/react */
import { loaderImage, useTheme } from '@quickbit/qb-design-system';

export const QBLoader = () => {
  const { spacing } = useTheme();
  return (
    <div
      css={{
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <img css={{ width: spacing.l }} src={loaderImage} aria-hidden="true" />
    </div>
  );
};
